import { Controller } from '@hotwired/stimulus'

// 診断ウィジェットの4ステッププルダウンの順次活性化ロジック（issue #13041）。
// 参考: コラムCTA(form-cta.js)。入居時期→現在の状況→性別→年齢の順に選択させ、
// 前のステップ選択完了で次を活性化、完了ステップに緑チェック、4つ目選択でCTAを活性化する。
// PC/SP の component_controller はこのクラスを継承して使う。
export default class extends Controller {
  static targets = ['select', 'item', 'cta']
  static classes = ['current', 'done', 'ctaDisabled']

  // select と item はインデックスで対応する前提。マークアップ改修で本数がずれると
  // 別ステップを操作する等の不具合がサイレントに起きるため、不一致を検知してログに残す。
  connect () {
    if (this.selectTargets.length !== this.itemTargets.length) {
      console.error(
        `[ConsultationWidget] target本数不一致: select=${this.selectTargets.length}, item=${this.itemTargets.length}`,
      )
    }
  }

  // 値が空に戻された場合はそのステップを current に戻し、以降をリセットしてCTAを不活性化。
  // 値があれば done にして次を活性化。最後のステップ選択でCTAを活性化。
  change (event) {
    const index = this.selectTargets.indexOf(event.target)
    if (index < 0) return

    if (!event.target.value) {
      this.setCurrent(index)
      this.resetFrom(index + 1)
      this.disableCta()
      return
    }

    this.setDone(index)

    if (index === this.selectTargets.length - 1) {
      this.enableCta()
    }
  }

  // CTAが不活性な状態でのクリックは遷移させない
  onCtaClick (event) {
    if (this.hasCtaTarget && this.ctaTarget.classList.contains(this.ctaDisabledClass)) {
      event.preventDefault()
    }
  }

  setCurrent (index) {
    const item = this.itemTargets[index]
    if (!item) return
    item.classList.add(this.currentClass)
    item.classList.remove(this.doneClass)
  }

  setDone (index) {
    const item = this.itemTargets[index]
    if (item) {
      item.classList.remove(this.currentClass)
      item.classList.add(this.doneClass)
    }

    const nextSelect = this.selectTargets[index + 1]
    const nextItem = this.itemTargets[index + 1]
    if (!nextSelect) return

    nextSelect.disabled = false
    if (nextItem && !nextSelect.value) {
      nextItem.classList.add(this.currentClass)
      nextItem.classList.remove(this.doneClass)
    }
  }

  // index以降のステップを未選択状態（disabled）に戻す。
  // select.value も空に戻さないと、戻って再選択した際に保持値が残り、
  // 同じ値を選び直しても change が発火せず enableCta() が呼ばれない（CTAが詰まる）ため値もリセットする。
  resetFrom (index) {
    for (let i = index; i < this.itemTargets.length; i++) {
      const item = this.itemTargets[i]
      const select = this.selectTargets[i]
      if (item) item.classList.remove(this.doneClass, this.currentClass)
      if (select) {
        select.value = ''
        select.disabled = true
      }
    }
  }

  enableCta () {
    if (!this.hasCtaTarget) return
    this.ctaTarget.classList.remove(this.ctaDisabledClass)
    this.ctaTarget.setAttribute('aria-disabled', 'false')
  }

  disableCta () {
    if (!this.hasCtaTarget) return
    this.ctaTarget.classList.add(this.ctaDisabledClass)
    this.ctaTarget.setAttribute('aria-disabled', 'true')
  }
}
